module.exports = __webpack_public_path__ + "img/75ne.12adc33e.svg";